import React from "react";
import { Box, Typography, Tooltip, IconButton } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Alert from "@material-ui/lab/Alert";
import { toast } from "react-toastify";
import { i18n } from "../../../translate/i18n";
import { useStyles } from "../messagesAPIStyles";

const METHOD_COLORS = {
  GET: "#16a34a",
  POST: "#2563eb",
  PUT: "#f59e0b",
  DELETE: "#dc2626",
};

const copy = (text) => {
  try {
    navigator.clipboard.writeText(text);
    toast.success(i18n.t("messagesAPI.reference.copied"));
  } catch (_) {
    /* clipboard no disponible */
  }
};

/** Bloque de código con botón copiar. */
export const CodeBlock = ({ label, children }) => {
  const classes = useStyles();
  return (
    <>
      {label && <Typography className={classes.codeLabel}>{label}</Typography>}
      <Box className={classes.codeBlock}>
        <Tooltip title={i18n.t("messagesAPI.reference.copy")}>
          <IconButton size="small" className={classes.copyBtn} onClick={() => copy(children)}>
            <FileCopyOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        {children}
      </Box>
    </>
  );
};

/**
 * Tarjeta de referencia de un endpoint (estilo API docs profesional).
 * Sin formularios de prueba: solo documentación consumible por integradores.
 */
const EndpointCard = ({
  method = "POST",
  path,
  badges = [],
  title,
  description,
  params = [],
  request,
  response,
  curl,
  note,
  noteSeverity = "warning",
}) => {
  const classes = useStyles();
  const color = METHOD_COLORS[method] || "#2563eb";

  return (
    <Box className={classes.epCard}>
      <Box className={classes.epHead}>
        <span className={classes.methodBadge} style={{ backgroundColor: color }}>
          {method}
        </span>
        <span className={classes.epPath}>{path}</span>
        <Tooltip title={i18n.t("messagesAPI.reference.copy")}>
          <IconButton size="small" onClick={() => copy(path)} style={{ color: "inherit" }}>
            <FileCopyOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        {badges.map((b) => (
          <span
            key={b.label}
            className={classes.methodBadge}
            style={{ backgroundColor: b.color, fontSize: 10 }}
          >
            {b.label}
          </span>
        ))}
      </Box>

      {title && <Typography className={classes.epTitle}>{title}</Typography>}
      {description && <Typography className={classes.epDesc}>{description}</Typography>}

      {params.length > 0 && (
        <table className={classes.paramTable}>
          <thead>
            <tr>
              <th>{i18n.t("messagesAPI.reference.paramName")}</th>
              <th>{i18n.t("messagesAPI.reference.paramValue")}</th>
            </tr>
          </thead>
          <tbody>
            {params.map((p) => (
              <tr key={p.name}>
                <td>{p.name}</td>
                <td>{p.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {request && <CodeBlock label={i18n.t("messagesAPI.reference.request")}>{request}</CodeBlock>}
      {response && <CodeBlock label={i18n.t("messagesAPI.reference.response")}>{response}</CodeBlock>}
      {curl && <CodeBlock label={i18n.t("messagesAPI.reference.curl")}>{curl}</CodeBlock>}

      {note && (
        <Alert severity={noteSeverity} style={{ marginTop: 12 }}>
          {note}
        </Alert>
      )}
    </Box>
  );
};

export default EndpointCard;
